import { render, staticRenderFns } from "./BeforePlay.vue?vue&type=template&id=57275018&scoped=true&"
import script from "./BeforePlay.vue?vue&type=script&lang=js&"
export * from "./BeforePlay.vue?vue&type=script&lang=js&"
import style0 from "./BeforePlay.vue?vue&type=style&index=0&id=57275018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57275018",
  null
  
)

export default component.exports